const labels: Record<string, string> = {
  active: "Activo",
  draft: "Borrador",
  closed: "Cerrado",
  invited: "Invitado",
  confirmed: "Confirmado",
  declined: "No participa",
  pending: "Pendiente",
  in_review: "En evaluación",
  accepted: "Aceptado",
  rejected: "Rechazado",
  withdrawn: "Retirado por el autor",
  scheduled: "Programado",
  sent: "Enviado",
  live: "En vivo",
  cancelled: "Cancelado",
};

export function StatusBadge({ status }: { status: string }) {
  return <span className={`status-badge status-${status}`}>{labels[status] || status}</span>;
}
